import { createContext, useMemo, useState } from "react"
import * as PropTypes from "prop-types"

export const RentingContext = createContext({})

function RentingContextProvider({
  children,
  cars,
  preOwnedCars,
  kilometers,
  durations,
  brands,
  provinces,
  variant,
  footerLinks,
  landingsList,
  page,
  sellingStatus,
  initialFilter,
  disableUrlFilters
}) {
  const [withoutTaxes, setWithoutTaxes] = useState(false)

  const allCars = useMemo(() => [...cars, ...preOwnedCars], [cars, preOwnedCars])

  return (
    <RentingContext.Provider
      value={{
        cars,
        preOwnedCars,
        allCars,
        kilometers,
        sellingStatus,
        durations,
        brands,
        provinces,
        variant,
        page,
        withoutTaxes,
        setWithoutTaxes,
        footerLinks,
        landingsList,
        initialFilter,
        disableUrlFilters
      }}>
      {children}
    </RentingContext.Provider>
  )
}

RentingContextProvider.defaultProps = {
  preOwnedCars: [],
  provinces: [],
  footerLinks: [],
  landingsList: [],
  variant: "stock",
  sellingStatus: "new",
  initialFilter: {},
  disableUrlFilters: false
}

RentingContextProvider.propTypes = {
  cars: PropTypes.array.isRequired,
  preOwnedCars: PropTypes.array,
  kilometers: PropTypes.array.isRequired,
  durations: PropTypes.array.isRequired,
  footerLinks: PropTypes.array,
  landingsList: PropTypes.array,
  brands: PropTypes.object.isRequired,
  provinces: PropTypes.array,
  children: PropTypes.node.isRequired,
  page: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["stock", "commercial", "pre-owned", "flexible"]),
  sellingStatus: PropTypes.string,
  initialFilter: PropTypes.object,
  disableUrlFilters: PropTypes.bool
}

export default RentingContextProvider
